/* global $:false */

export default class DetailsWithCachedState {
  static init () {
    document.querySelectorAll('.js-details').forEach(el => DetailsWithCachedState.setupElement(el))
  }

  static setupElement (el) {
    const details = new DetailsWithCachedState(el)
    details.setupEventListener()
    details.recallState()
  }

  constructor (el) {
    this.el = el
    this.cacheKey = this.el.dataset.cacheKey
  }

  setupEventListener () {
    this.el.addEventListener('toggle', event => {
      this.rememberState(event.target.open)
    })
  }

  rememberState (open) {
    if (!this.cacheKey) { return }
    window.localStorage.setItem(`details.${this.cacheKey}.open`, open)
  }

  recallState () {
    if (!this.cacheKey) { return }
    const cachedState = window.localStorage.getItem(`details.${this.cacheKey}.open`)
    if (cachedState === 'true') {
      this.el.open = true
    } else if (cachedState === 'false') {
      this.el.open = false
    }
  }
}
